import { DEFAULT_LETTERHEAD } from './page-template';
import type { PrintLetterhead } from './types';

/** Company Settings keys holding the uploaded print letterhead (base64 data URLs); mirrors the backend. */
export const PRINT_LETTERHEAD_HEADER_KEY = 'print_letterhead_header';
export const PRINT_LETTERHEAD_FOOTER_KEY = 'print_letterhead_footer';

type CompanySettingsMap = Record<string, { value?: unknown } | undefined> | null | undefined;

let uploaded: { headerSrc: string; footerSrc: string } = { headerSrc: '', footerSrc: '' };

const asImageSrc = (v: unknown): string => {
  const s = v == null ? '' : String(v).trim();
  return /^(data:image\/|https?:\/\/|\/)/i.test(s) ? s : '';
};

/** Called whenever company settings load or change, so prints opened afterwards use the uploaded artwork. */
export function setCompanyLetterheadFromSettings(settings: CompanySettingsMap): void {
  uploaded = {
    headerSrc: asImageSrc(settings?.[PRINT_LETTERHEAD_HEADER_KEY]?.value),
    footerSrc: asImageSrc(settings?.[PRINT_LETTERHEAD_FOOTER_KEY]?.value),
  };
}

/** Letterhead for prints: the company's uploaded header / footer, each falling back to the built-in artwork. */
export function getCompanyLetterhead(): PrintLetterhead {
  return {
    headerSrc: uploaded.headerSrc || DEFAULT_LETTERHEAD.headerSrc,
    footerSrc: uploaded.footerSrc || DEFAULT_LETTERHEAD.footerSrc,
  };
}

/** Absolute URL for prints written into a separate document (blob / about:blank), where root-relative paths break. */
export function absoluteLetterheadSrc(src: string): string {
  if (src.startsWith('/') && typeof window !== 'undefined') return `${window.location.origin}${src}`;
  return src;
}
